import { DateTime } from "luxon";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { ControlledMantineEditDateInput } from "../../../../../mantine/mrt/components/edit/ControlledMantineEditDateInput";
import { submitOrCancelOnKeyPress } from "../../../../../mantine/mrt/utils/submitOrCancelOnKeyPress";
import type { InlineEditTableColumnData } from "../../../../../types/inlineEditTable.types";
import { backendDateOrDateTimeToLuxonDateTimeOrNull } from "../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTimeOrNull";
import { DATE_DISPLAY_FORMAT } from "../../../../../utils/dates/dates.constants";
import type { PPAInvoiceNumberRange } from "../../PPAInvoiceNumberRangesPage.types";

export function getValidFromColumn({
  validationErrors
}: InlineEditTableColumnData): MRT_ColumnDef<PPAInvoiceNumberRange> {
  return {
    accessorKey: "valid_from",
    header: "Startdatum",
    enableSorting: true,
    size: 300,
    accessorFn: (row) =>
      backendDateOrDateTimeToLuxonDateTimeOrNull(row.valid_from)?.toJSDate() ??
      null,
    Cell: ({ cell }) => {
      const cellValue = cell.getValue<Date | null>();

      return cellValue
        ? DateTime.fromJSDate(cellValue).toFormat(DATE_DISPLAY_FORMAT)
        : null;
    },
    Edit: ({ cell, column, row, table }) => (
      <ControlledMantineEditDateInput
        cell={cell}
        columnId={column.id}
        errorText={validationErrors.valid_from}
        label="Startdatum"
        placeholder="Bsp.: 01.01.2026"
        row={row}
        table={table}
        onKeyDown={(event) => submitOrCancelOnKeyPress(event, table)}
      />
    )
  };
}
